<mat-nav-list>
  <item-menu *ngFor="let item of infoMenu" [infoMenu]="item"></item-menu>
</mat-nav-list>